import BaseApi from "./BaseApi";

export default class ResetPasswordApi extends BaseApi {
  static checkUser = userid => this.post("getUser.htm", { userid });

  static checkAnswer = (userid, answer) => this.post("checkAnswer.htm", { userid, answer });

  static resetPassword = (userid, password, answer) => this.post("setPassword.htm", { userid, password, answer });
}
